import { ELkType } from '../../types/lkType';
import { TAppState } from '../../types/appState';

export const isSearcherSelector = (state: TAppState) => {
  if (!state.lkType) {
    return true;
  }

  return state.lkType.lkType === ELkType.Searcher;
};
